import { FullscreenCarousel } from '@cian/frontend-fullscreen-carousel-component';

import { Component } from 'react';

import { ContactModal } from '../../ContactModal';
import { Counter } from '../Counter';

import { Header } from './Header';
import { IFullscreenGalleryProps, IFullscreenGalleryState } from './types';
import { prepareSlides } from './utils';

export class FullscreenGallery extends Component<IFullscreenGalleryProps, IFullscreenGalleryState> {
  public constructor(props: IFullscreenGalleryProps) {
    super(props);

    this.state = {
      slides: prepareSlides(props.images),
      showContactModal: false,
    };
  }

  public componentDidMount() {
    const { onOpen } = this.props;

    if (onOpen) {
      onOpen();
    }
  }

  private handlePhoneButtonClick = () => {
    this.setState({ showContactModal: true });
  };

  private handleOnModalClose = () => {
    this.setState({ showContactModal: false });
  };

  public render() {
    const { defaultSlideIndex, onClose, onSlideChange } = this.props;
    const { slides, showContactModal } = this.state;

    return (
      <>
        <FullscreenCarousel
          defaultCurrentSlide={defaultSlideIndex}
          media={[
            {
              minWidth: -Infinity,
              maxWidth: 1024,
              options: {
                defaultControls: [],
                hideThumbnails: true,
                contentOptions: {
                  headerContent: (
                    <Header onPhoneButtonClick={this.handlePhoneButtonClick}>
                      <Counter currentSlide={defaultSlideIndex || 1} totalSlides={slides.length} />
                    </Header>
                  ),
                },
              },
            },
            {
              minWidth: 1024,
              maxWidth: Infinity,
              options: {
                contentOptions: {
                  headerContent: <Header onPhoneButtonClick={this.handlePhoneButtonClick} />,
                },
              },
            },
          ]}
          slides={slides}
          onClose={onClose}
          onSlideChange={onSlideChange}
        />
        {showContactModal && <ContactModal onClose={this.handleOnModalClose} />}
      </>
    );
  }
}
